import React, { useRef, useEffect } from 'react';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import Contact from 'modules/MainModule/components/Contact/Contact';
import { airlegitAddress } from 'data/common.data';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { uiURL } from 'data/common.data';

const Privacy = (props: any) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Stranded Passenger Protection Privacy Policy</title>
                    <meta name='description' content='Get Flight Watcher to alert you on flight delays, cancellation. Choose alternative airlines, nearby airports, re-booking, or re-accommodation.' />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='privacy-data-container page-min-height container-side-padding container-content-padding'>
                <div className='container no-padding'>
                    <div className='row no-margin'>
                        <div className='col-md-12 no-padding text-justify'>
                            <p>
                                Protecting your private information is our priority. This Statement of Privacy applies
                                to <a href={uiURL} className='text-link'>{uiURL}</a> and Cognitive Junction and
                                governs data collection and usage. For the purposes of this Privacy Policy, unless
                                otherwise noted, all references to Cognitive Junction include <a href={uiURL} className='text-link'>{uiURL}</a> and AirLegit. The AirLegit website is a AirLegit's Products and Services site. By using the AirLegit website, you
                                consent to the data practices described in this statement.
                            </p>
                            <br />
                            <h3 className='text-l2'>Collection of your Personal Information</h3>
                            <p>
                                We do not collect any personal information about you unless you sign up for AirLegit's
                                services through travel agency, OTAs or Airlines and provide it to us through them.
                                Information about you is required to perform services such as flight status, alerts when
                                delayed or cancelled, proving you alternative flight information, providing you gate or
                                terminal information for your pre departure process. To wit, we will use your
                                information for, but not limited to, communicating with you in relation to services
                                and/or products you have requested from us. We also may gather additional personal or
                                non-personal information in the future.
                            </p>
                            <p>
                                If your travel agency or airline has contracted with us to provide you with our flight
                                alerts messaging service, their representatives may be authorized to view the contact
                                information you (or they) have provided to us in order to assist you with flight-related
                                problems
                            </p>
                            <br />
                            <h3 className='text-l2'>Sharing Information with Third Parties.</h3>
                            <p>
                                AirLegit does not sell, rent or lease its customer lists to third parties.
                            </p>
                            <p>
                                AirLegit may share data with trusted partners to help perform travel watcher services,
                                alerts, send you email or provide you access to prioritized customer support phone
                                numbers for your travel agency. All such third parties are prohibited from using your
                                personal information except to provide these services to AirLegit, and they are required
                                to maintain the confidentiality of your information.
                            </p>
                            <p>
                                AirLegit may disclose your personal information, without notice, if required to do so by
                                law or in the good faith belief that such action is necessary to: (a) conform to the
                                edicts of the law or comply with legal process served on AirLegit or the site; (b)
                                protect and defend the rights or property of AirLegit; and/or (c) act under exigent
                                circumstances to protect the personal safety of users of AirLegit, or the public.
                            </p>
                            <br />
                            <h3 className='text-l2'>Automatically Collected Information</h3>
                            <p>
                                Information about your computer hardware and software may be automatically collected by
                                AirLegit. This information can include: your IP address, browser type, domain names,
                                access times and referring website addresses. This information is used for the operation
                                of the service, protect our website with security, to maintain quality of the service,
                                and to provide general statistics regarding use of the AirLegit website.
                            </p>
                            <p>
                                Such information may be used to track site trends and enhance the user experience, and
                                may be shared with third parties in aggregated, non-personally identifiable form. To the
                                extent third parties may place advertising on the Site, such third parties may use
                                cookies, or other technological means within the advertising to collect and use
                                non-personally identifiable information. AirLegit is not responsible for information
                                collected by third parties in this manner, nor for the collection or use of Information
                                by other sites to which the Site is linked.
                            </p>
                            <br />
                            <h3 className='text-l2'>Security of your Personal Information </h3>
                            <p>
                                AirLegit secures your personal information from unauthorized access, use, or disclosure.
                                AirLegit uses the following methods for this purpose:
                            </p>
                            <p>
                                SSL Protocol
                            </p>
                            <p>
                                We strive to take appropriate security measures to protect against unauthorized access
                                to or alteration of your personal information. Unfortunately, no data transmission over
                                the Internet or any wireless network can be guaranteed to be 100% secure. As a result,
                                while we strive to protect your personal information, you acknowledge that: (a) there
                                are security and privacy limitations inherent to the Internet which are beyond our
                                control; and (b) security, integrity, and privacy of any and all information and data
                                exchanged between you and us through this Site cannot be guaranteed.
                            </p>
                            <p>
                            </p>
                            <br />
                            <h3 className='text-l2'>Right to Deletion</h3>
                            <p className='no-margin'>
                                Subject to certain exceptions set out below, on receipt of a verifiable request from
                                you, we will:
                            </p>
                            <ul>
                                <li>
                                    Delete your personal information from our records; and
                                </li>
                                <li>
                                    Direct any service providers to delete your personal information from their records.
                                </li>
                            </ul>
                            <p className='no-margin'>
                                Please note that we may not be able to comply with requests to delete your personal
                                information if it is necessary to:
                            </p>
                            <ul>
                                <li>
                                    Complete the transaction for which the personal information was collected, fulfill the
                                    terms of a written warranty or product recall conducted in accordance with federal law,
                                    provide a good or service requested by you, or reasonably anticipated within the context
                                    of our ongoing business relationship with you, or otherwise perform a contract between
                                    you and us;
                                </li>
                                <li>
                                    Detect security incidents, protect against malicious, deceptive, fraudulent, or
                                    illegal activity; or prosecute those responsible for that activity;
                                </li>
                                <li>
                                    Debug to identify and repair errors that impair existing intended functionality;
                                </li>
                                <li>
                                    Exercise free speech, ensure the right of another consumer to exercise his or her
                                    right of free speech, or exercise another right provided for by law;
                                </li>
                                <li>
                                    Comply with the California Electronic Communications Privacy Act;
                                </li>
                                <li>
                                    Engage in public or peer-reviewed scientific, historical, or statistical research in
                                    the public interest that adheres to all other applicable ethics and privacy laws, when
                                    our deletion of the information is likely to render impossible or seriously impair the
                                    achievement of such research, provided we have obtained your informed consent;
                                </li>
                                <li>
                                    Enable solely internal uses that are reasonably aligned with your expectations based
                                    on your relationship with us;
                                </li>
                                <li>
                                    Comply with an existing legal obligation; or
                                </li>
                                <li>
                                    Otherwise use your personal information, internally, in a lawful manner that is
                                    compatible with the context in which you provided the information.
                                </li>
                            </ul>
                            <br />
                            <h3 className='text-l2'>Children Under Thirteen</h3>
                            <p>
                                AirLegit does not knowingly collect personally identifiable information from children
                                under the age of thirteen. If you are under the age of thirteen, you must ask your
                                parent or guardian for permission to use this website.
                            </p>
                            <br />
                            <h3 className='text-l2'>E-mail or SMS Communications </h3>
                            <p>
                                For the purpose of AirLegit's subscription services, AirLegit may send you flight alerts
                                via email or SMS services (opted in customers for phone alerts) for the purpose of
                                providing flight status, delays, cancelation, terminal info, gate info to help you
                                prepare for your forthcoming travel.
                            </p>
                            <p>
                                If you would like to stop receiving any such email from AirLegit, you may opt out of
                                such communications by Clicking Unsubscribe link at the bottom of the email. For SMS
                                messages, simply type STOP to discontinue SMS services on flight alerts.
                            </p>
                            <br />
                            <h3 className='text-l2'>Changes to this Statement</h3>
                            <p>
                                AirLegit reserves the right to change this Privacy Policy from time to time. We will
                                update with notification if there is any material changes to the way we collect
                                information or processing your personal information, any significant changes in the way
                                we treat personal information by placing a prominent notice on our site, and/or by
                                updating any privacy information on this page. Your continued use of the Site and/or
                                Services available through this Site after such modifications will constitute your: (a)
                                acknowledgment of the modified Privacy Policy; and (b) agreement to abide and be bound
                                by that Policy.
                            </p>
                            <br />
                            <h3 className='text-l2'>Contact Information</h3>
                            <p>
                                AirLegit welcomes your questions or comments regarding this Statement of Privacy. If you
                                believe that AirLegit has not adhered to this Statement, please contact AirLegit at:
                            </p>
                            <p>
                                {airlegitAddress.name} (Congnitive Junction Inc. DBA AirLegit)
                                < br />
                                {airlegitAddress.line1}
                                < br />
                                {airlegitAddress.line2}
                                < br />
                                {airlegitAddress.city}, {airlegitAddress.stateCode} - {airlegitAddress.zipcode}
                            </p>
                            <p>
                                Email Address:<br />
                                <a href='mailto:care@airlegit.com' className='text-link'>care@airlegit.com</a>
                            </p>
                            <p>
                                Telephone number:<br />
                                <a href='tel:3476744960' className='text-link'>3476744960</a>
                            </p>
                            <p>
                                Effective as of September 01, 2020
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <Contact />
            <Footer />
        </>
    );
};

export default Privacy;